import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useInView } from "react-intersection-observer";

import { useInfiniteUserReviews } from "../../../User/api/queries/useUserReviews";

import TestimonialCard from "../../components/Testimonials/TestimonialCard";

const TestimonialsList = () => {
  const { userId } = useParams();
  const {
    data: reviewsData,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    isLoading,
    isError,
  } = useInfiniteUserReviews(userId!);
  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage, isFetchingNextPage]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      {reviewsData?.items.map((review, index) => (
        <TestimonialCard key={index} review={review} />
      ))}
      {(isFetchingNextPage || isLoading) && (
        <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
          <CircularProgress />
        </Box>
      )}
      <Box ref={ref} sx={{ height: "20px" }} />
    </Box>
  );
};

export default TestimonialsList;
